import React, {
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import "./FeedbackDisplay.css";
import { getRandomPosition, getRandomMessage } from "../../utils/positions";

// Now handles an array of feedback messages
const FeedbackDisplay = forwardRef(function FeedbackDisplay(
  { onFeedbackComplete },
  ref
) {
  const [feedbacks, setFeedbacks] = useState([]);

  const addFeedback = useCallback(
    (message, type, correctTime, userTime, points) => {
      setFeedbacks((prevFeedbacks) => {
        // Create new feedback object
        const newFeedback = {
          id: Date.now(), // Unique ID for each feedback
          message:
            message == "randomMessage"
              ? getRandomMessage(type, correctTime, userTime, points)
              : message,
          type,
          position: getRandomPosition(),
        };

        // If we already have 2 messages, remove the oldest one (FIFO)
        const updatedFeedbacks =
          prevFeedbacks.length >= 2
            ? [...prevFeedbacks.slice(1), newFeedback]
            : [...prevFeedbacks, newFeedback];

        // Remove feedback after animation completes
        setTimeout(() => {
          setFeedbacks((current) =>
            current.filter((f) => f.id !== newFeedback.id)
          );
          if (onFeedbackComplete) {
            onFeedbackComplete();
          }
        }, 2000); // Match this with your CSS animation duration

        return updatedFeedbacks;
      });
    },
    [onFeedbackComplete]
  );

  // Expose addFeedback method to parent component
  useImperativeHandle(ref, () => addFeedback, [addFeedback]);

  return (
    <div className="feedback-container">
      {feedbacks.map((feedback) => (
        <div
          key={feedback.id}
          className={`feedback ${
            feedback.type === "Good" || feedback.type === "GoodPoints"
              ? "correct"
              : "incorrect"
          }`}
          style={{
            left: `${feedback.position.x}px`,
            top: `${feedback.position.y}px`,
          }}
        >
          {feedback.message}
        </div>
      ))}
    </div>
  );
});

// Add display name for better debugging
FeedbackDisplay.displayName = "FeedbackDisplay";

export default FeedbackDisplay;
